import { section } from "@/neon";

import { animateBlog } from "@/lib/animation";

section("blog", {
  onLoad() {
    this.animateBlog = animateBlog(this.container);
  },
  onUnload() {
    this.animateBlog?.destroy();
  },
});
